'use client'
import { FaSearch } from 'react-icons/fa'
import { useState, useEffect } from 'react'
import { updateSearchParams, removeSearchParam, getSearchParams } from "@utils";
import { useRouter } from 'next/navigation'
import LinkComponent from '@components/LinkComponent';

const IdFilter = ({ title, dictionary }) => {
    const router = useRouter();
    const [id, setId] = useState('');
    const [debouncedId, setDebouncedId] = useState('');

    useEffect(() => {
        const nameValue = getSearchParams('name');
        setId(nameValue || '');
    }, []);

    // Debounce logic
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedId(id);
        }, 500); // 500ms debounce

        return () => {
            clearTimeout(handler);
        };
    }, [id]);

    useEffect(() => {
        if (debouncedId === '' || debouncedId === null || debouncedId === undefined) {
            router.push(removeSearchParam(title));
        } else {
            router.push(updateSearchParams(title, debouncedId));
        }
    }, [debouncedId]);

    return (
        <div className='w-full flex flex-col items-left justify-start'>
            <div className='flex flex-row items-center mt-3'>
                <input
                    className='w-full rounded-l-sm py-2 border-[1px] border-forth text-secondary pl-2 text-sm leading-5 focus:ring-0'
                    placeholder={dictionary.filter.enterListingId}
                    type='text'
                    name='id'
                    value={id}
                    onChange={(e) => {
                        setId(e.target.value)
                    }}
                // required
                />
                {/* </div> */}
                <LinkComponent href={`/properties?name=${id}`}>
                    <button className='bg-maincolor p-3 rounded-r-sm border-none' id="id" aria-label="Search by ID" >
                        <FaSearch
                            color='white'
                        />
                    </button>
                </LinkComponent>
            </div>
        </div>
    )
}

export default IdFilter